import React, { FC } from 'react'
import {
  Col, Image, Row, Space, Typography,
} from 'antd'
import ReactMarkdown from 'react-markdown'

import { ICompanyInfoProps } from './CompanyInfo.types'

const { Text } = Typography

export const CompanyInfo: FC<ICompanyInfoProps> = ({ settings: { description, logo, company } }) => (
  <Row
    align="middle"
    data-testid="company-info"
    gutter={8}
    justify="center"
    style={{ flexFlow: 'row' }}
  >
    {logo && (
      <Col flex="100px">
        <Image preview={false} src={logo} />
      </Col>
    )}
    <Col flex="auto">
      <Space direction="vertical" size={2}>
        <Text strong>{company.label}</Text>
        {description && (
          <Text>
            <ReactMarkdown components={{
              p: ({ ...props }) => <p style={{ marginBottom: 0 }} {...props} />,
            }}
            >
              {description}
            </ReactMarkdown>
          </Text>
        )}
      </Space>
    </Col>
  </Row>
)
